import { createSelector } from 'reselect';
import { getIsMESEnabled } from './getIsMESEnabled';
import { getMachineSettings } from './getMachineSettings';
import { getMachineErpResourceIdFromApi } from './getApiErpResources';

/** Replaces master `machine.erpResourceId` (SET_MACHINE_ERP_RESOURCES + settings side effects). */
export const getEffectiveErpResourceId = createSelector(
  [getIsMESEnabled, getMachineSettings, getMachineErpResourceIdFromApi],
  (mesEnabled, machineSettings, erpResourceIdFromApi) => {
    const rawLaborResourceId = machineSettings?.laborResourceId;
    const laborResourceId =
      rawLaborResourceId != null && rawLaborResourceId !== ''
        ? rawLaborResourceId
        : null;
    const apiErpResourceId =
      erpResourceIdFromApi != null && erpResourceIdFromApi !== ''
        ? erpResourceIdFromApi
        : null;

    if (mesEnabled && laborResourceId != null) {
      return laborResourceId;
    }

    return apiErpResourceId ?? (mesEnabled ? laborResourceId : null);
  }
);
